document.addEventListener("DOMContentLoaded", () => {
    const richtextBlocks = document.querySelectorAll<HTMLElement>(".feature-richtext");

    richtextBlocks.forEach((block) => {
        const h2 = block.querySelector("h2");
        if (!h2) return;

        // Collect all h3 and p elements that come after the h2
        const siblings: Element[] = [];
        let sibling = h2.nextElementSibling;
        while (sibling) {
            siblings.push(sibling);
            sibling = sibling.nextElementSibling;
        }

        // Create the outer wrapper
        const outerWrapper = document.createElement("div");
        outerWrapper.classList.add("features-outer-wrapper");

        // Group h3 + p pairs into inner divs
        let innerDiv: HTMLDivElement | null = null;

        siblings.forEach((el) => {
            if (el.tagName === "H3") {
                // Start a new inner div for each h3
                innerDiv = document.createElement("div");
                innerDiv.classList.add("feature-item");
                innerDiv.appendChild(el);
                outerWrapper.appendChild(innerDiv);
            } else if (el.tagName === "P" && innerDiv) {
                // Append p to the current inner div
                innerDiv.appendChild(el);
            }
        });

        // Insert the outer wrapper after the h2
        h2.after(outerWrapper);
    });
});

document.addEventListener("DOMContentLoaded", () => {
    const featureBlocks = document.querySelectorAll<HTMLElement>("[data-feature-block]");
    const tocContainer = document.querySelector<HTMLElement>("[data-toc-links]");

    if (!tocContainer || featureBlocks.length === 0) return;

    featureBlocks.forEach((block) => {
        const badge = block.querySelector("badge");
        if (!badge || !badge.textContent) return;

        const text = badge.textContent.trim();
        const slug = text.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");

        // Set id on the feature block for anchor linking
        block.id = slug;

        // Create the toc link as an anchor
        const tocLink = document.createElement("a");
        tocLink.className = "feature-toc-link";
        tocLink.setAttribute("data-toc-link", slug);
        tocLink.href = `#${slug}`;

        // Smooth scroll with offset
        tocContainer.addEventListener("click", (e) => {
            const link = (e.target as HTMLElement).closest("a.feature-toc-link");
            if (!link) return;

            e.preventDefault();
            e.stopPropagation();

            const slug = link.getAttribute("data-toc-link");
            if (!slug) return;

            const target = document.getElementById(slug);
            console.log("slug:", slug, "target:", target); // debug

            if (!target) return;

            const top = target.getBoundingClientRect().top + window.scrollY - 100;
            window.scrollTo({ top, behavior: "smooth" });
        });

        // Create the text div
        const tocText = document.createElement("div");
        tocText.setAttribute("data-toc-link-text", slug);
        tocText.textContent = text;

        tocLink.appendChild(tocText);
        tocContainer.appendChild(tocLink);
    });
});